import React from 'react';
import { View, Text, StyleSheet, TouchableHighlight } from 'react-native';
import { Large } from '@dbk/ui-text';
import styles from './row.styles';

const PortfolioPositionRow = (props) => {
  return (
    <div onClick={() => props.selectedRow(props)}>
        <Text style={styles.pfText}>
          <Large>{props.pfId}</Large>
        </Text>
        <Text style={styles.text}>
          <Large>{props.psDesc}</Large>
        </Text>
    </div>
  );
};

export default PortfolioPositionRow;
